// src/components/NavigationSteps.jsx
import React from "react";
import { Link } from "react-router-dom";
import {
  CarOutlined,
  DeploymentUnitOutlined,
  EnvironmentOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { Card, Typography } from "antd";

const { Text } = Typography;

/**
 * @param {string} selectedKey - la clé (ou chemin) de l'étape sélectionnée
 */
export const NavigationStepsCapNoc = ({ selectedKey }) => {
  // Liste ordonnée des étapes (y compris le bouton incidents)
  const steps = [
    {
      key: "tetra_bus",
      title: "Temp 1",
      label: "Validation TETRA BUS",
      path: "/7b0cc0d68f23/cap_noc/tetra_bus",
      icon: <CarOutlined />,
    },
    {
      key: "prise_service",
      title: "Temp 2",
      label: "Validation Prise de service SAE ",
      path: "/7b0cc0d68f23/cap_noc/prise_service",
      icon: <DeploymentUnitOutlined />,
    },
    {
      key: "geolocalisation",
      title: "Temp 3",
      label: "Géolocalisation de l'AD",
      path: "/7b0cc0d68f23/cap_noc/geolocalisation",
      icon: <EnvironmentOutlined />,
    },
/*
    {
      key: "incidents_habilitations",
      title: "Déclarer Incidents",
      label: "Habilitations / Accès",
      path: "/7b0cc0d68f23/declarations_pb_cap", // ✅ navigation interne
      icon: <ExclamationCircleOutlined />,
    },
*/
  ];

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "12px",
        justifyContent: "center",
        marginBottom: "20px",
      }}
    >
      {steps.map((step) => {
        const active = selectedKey === step.key;

        return (
          <Link key={step.key} to={step.path} style={{ textDecoration: "none" }}>
            <Card
              hoverable
              size="small"
              style={{
                width: 180,
                height: 90,
                borderRadius: 10,
                boxShadow: active
                  ? "0 0 8px rgba(24, 144, 255, 0.6)"
                  : "0 1px 5px rgba(0,0,0,0.1)",
                borderColor: active ? "#1677ff" : "#f0f0f0",
                transition: "all 0.2s ease",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ fontSize: 22, color: active ? "#1677ff" : "#999" }}>
                {step.icon}
              </div>
              <Text strong style={{ fontSize: 13 }}>
                {step.title}
              </Text>
              <div style={{ fontSize: 11, color: "#666", marginTop: 2 }}>
                {step.label}
              </div>
            </Card>
          </Link>
        );
      })}
    </div>
  );
};
